import { useRef } from 'react';

export type RefMap<K, V> = (key: K) => { current: V | null };

function makeRefMap<K, V>(): RefMap<K, V> {
	const map = new Map<K, { current: V | null }>();

	/** Create a new ref object and add it to the map. */
	const newValue = (key: K) => {
		const v = { current: null };
		map.set(key, v);
		return v;
	};

	return (key) => map.get(key) ?? newValue(key);
}

export function useRefMap<K, V>() {
	return useRef(makeRefMap<K, V>()).current;
}
